module.exports = __webpack_public_path__ + "static/media/terminal-outline.b78f1007.svg";